import { create } from 'zustand';

const STORAGE_KEY_PREFIX = 'loada:onboarding-completed';

function getStorageKey(userId: string | undefined): string {
  return userId ? `${STORAGE_KEY_PREFIX}:${userId}` : STORAGE_KEY_PREFIX;
}

function hasCompleted(userId: string | undefined): boolean {
  try {
    return localStorage.getItem(getStorageKey(userId)) === 'true';
  } catch {
    return false;
  }
}

function markComplete(userId: string | undefined): void {
  try {
    localStorage.setItem(getStorageKey(userId), 'true');
  } catch {
    // localStorage unavailable
  }
}

interface OnboardingStore {
  isOpen: boolean;
  activeUserId: string | undefined;
  open: () => void;
  close: () => void;
  complete: () => void;
  openIfFirstTime: (userId?: string) => void;
}

export const useOnboardingStore = create<OnboardingStore>((set, get) => ({
  isOpen: false,
  activeUserId: undefined,
  open: () => set({ isOpen: true }),
  close: () => {
    markComplete(get().activeUserId);
    set({ isOpen: false });
  },
  complete: () => {
    markComplete(get().activeUserId);
    set({ isOpen: false });
  },
  openIfFirstTime: (userId?: string) => {
    if (!hasCompleted(userId)) {
      set({ activeUserId: userId, isOpen: true });
    }
  },
}));
